import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';
import InviteParticipantStore from '../../../Store';

export interface Props {
  store: InviteParticipantStore;
}

function Submit({ store }: Props) {
  return (
    <div className="flex mt-16">
      <div
        className={clsx(
          'cursor-pointer rounded-md bg-white text-teal-600 border-teal-600 px-3 py-2 text-sm',
          'w-24 text-center mt-4 border mr-4',
        )}
        onClick={store.back}
      >
        <T kind="Back" />
      </div>
      <div
        className={clsx(
          'cursor-pointer rounded-md bg-teal-600 text-white px-3 py-2 text-sm w-24 text-center mt-4',
        )}
        onClick={store.submit}
      >
        <T kind="Submit" />
      </div>
    </div>
  );
}

export default observer(Submit);
